export const DEFAULT_TICKET_OVERVIEW_DATA = {
  balance: 0,
  paidAmount: 0,
  acceptedAmount: 0,
  wonTicketsCount: 0,
  lostTicketsCount: 0,
  acceptedTicketsCount: 0,
}
